import { FlyToInterpolator } from '@deck.gl/core/typed';
import IconButton from '@mui/material/IconButton';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { useViewState } from 'components/maps/BaseMap';
import { useKineticMap } from 'components/maps/MapContext/hooks/useKineticMap';
import { useTranslation } from 'react-i18next';

const ExploreIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d='M 8.266 6.093 L 12.189 15.089 L 4.342 15.089 L 8.266 6.093 Z'
        fill='red'
        transform='matrix(0.718242, 0.695794, -0.695794, 0.718242, 16.553265, -4.450986)'
      />
      <path d='M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' />
    </SvgIcon>
  );
};
export const ResetViewButton = () => {
  const map = useKineticMap();
  const viewState = useViewState(true);
  const { t } = useTranslation('maps');
  const bearing = viewState.bearing;
  // icon defaults to a 45 degree angle, so we need to offset it by the bearing
  const iconDegrees = -45 + -(bearing ?? 0);
  const iconPitch = (viewState.pitch ?? 0) / 1.5;
  return (
    <Tooltip title={t('resetBearingPitch')} placement='bottom'>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          map.setViewState({
            ...viewState,
            bearing: 0,
            pitch: 0,
            transitionDuration: 500,
            transitionInterpolator: new FlyToInterpolator(),
          });
        }}
      >
        <ExploreIcon
          style={{ transform: `rotate3d(1, 0, 0, ${iconPitch}deg) rotate(${iconDegrees}deg)` }}
        />
      </IconButton>
    </Tooltip>
  );
};
